import React from 'react';
import markImg from '../assets/brand/logo-mark.png';

/**
 * Veetu Saama — Brand Logo
 * Variants: 'full' (mark + wordmark), 'mark' (icon only), 'wordmark' (text only)
 * Themes:   'dark' (default — for light bg), 'light' (for dark bg)
 * showTagline: Show "EVERYTHING FOR A BETTER HOME" line
 */
const Logo = ({
  variant = 'full',
  theme = 'dark',
  size = 44,
  showTagline = false,
  className = '',
}) => {
  const wordDark = theme === 'dark' ? '#1a1410' : '#F7F4EA';
  const taglineColor = theme === 'dark' ? '#4D4D4D' : '#E9D6C1';

  const Mark = (
    <img
      src={markImg}
      alt="Veetu Saama"
      width={size}
      height={size}
      className="flex-shrink-0 select-none"
      style={{ width: size, height: size, objectFit: 'contain' }}
      draggable={false}
    />
  );

  const Wordmark = (
    <div className="flex flex-col leading-none">
      <div className="flex items-baseline gap-2">
        <span
          className="uppercase"
          style={{
            color: wordDark,
            fontFamily: "'Archivo Black', 'Anton', Impact, sans-serif",
            fontSize: size * 0.6,
            letterSpacing: '0.01em',
            lineHeight: 0.95,
          }}
        >
          Veetu
        </span>
        <span
          className="uppercase"
          style={{
            color: '#F58220',
            fontFamily: "'Archivo Black', 'Anton', Impact, sans-serif",
            fontSize: size * 0.6,
            letterSpacing: '0.01em',
            lineHeight: 0.95,
          }}
        >
          Saama
        </span>
      </div>
      {showTagline && (
        <span
          className="uppercase"
          style={{
            color: taglineColor,
            fontSize: Math.max(8, size * 0.14),
            letterSpacing: '0.34em',
            fontFamily: "'Poppins', sans-serif",
            fontWeight: 500,
            marginTop: size * 0.14,
          }}
        >
          Everything &nbsp;For&nbsp; a &nbsp;Better&nbsp; Home
        </span>
      )}
    </div>
  );

  if (variant === 'mark') return <div className={className}>{Mark}</div>;
  if (variant === 'wordmark') return <div className={className}>{Wordmark}</div>;

  return (
    <div className={`flex items-center gap-3 ${className}`}>
      {Mark}
      {Wordmark}
    </div>
  );
};

export default Logo;
